import React from 'react';
import PropTypes from 'prop-types';
import './AvisosNav.css';
import AvisosNavItem from '../AvisosNavItem';

const numOfItems = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

const AvisosNav = props => {
    const { avisosNavigation, markers, language, meteorsNav } = props;
    if (props.markers) {
        return (
            <div className="NavAvisos">
                {numOfItems.map(i => (
                    <AvisosNavItem
                        key={i}
                        type={i}
                        avisosNavigation={avisosNavigation}
                        isEnabled={meteorsNav[i]}
                        hasAvisos={
                            markers[i].perillModerat ||
                            markers[i].perillAlt ||
                            markers[i].perillMoltAlt
                        }
                        markers={markers[i]}
                        language={language}
                    />
                ))}
            </div>
        );
    }
    return (
        <div className="NavAvisos">
            {numOfItems.map(i => (
                <AvisosNavItem
                    key={i}
                    type={i}
                    isEnabled={false}
                    hasAvisos={false}
                    markers={{
                        perillModerat: false,
                        perillAlt: false,
                        perillMoltAlt: false,
                    }}
                    language={language}
                />
            ))}
        </div>
    );
};

AvisosNav.propTypes = {
    avisosNavigation: PropTypes.func,
    language: PropTypes.string,
    markers: PropTypes.arrayOf(
        PropTypes.shape({
            perillAlt: PropTypes.bool,
            perillModerat: PropTypes.bool,
            perillMoltAlt: PropTypes.bool,
        })
    ),
    meteorsNav: PropTypes.object,
};

export default AvisosNav;



// WEBPACK FOOTER //
// ./src/partials/AvisosNav/AvisosNav.js